const v = (val: string | undefined): string | undefined => val || undefined;

export const env = {
  AUTH0_CLIENT_ID: v(import.meta.env.REACT_APP_AUTH0_CLIENT_ID),
  AUTH0_DOMAIN: v(import.meta.env.REACT_APP_AUTH0_DOMAIN),
  // Dev only: mock the API's /auth/passwordless/* calls (see contexts/auth/mockAuthApi.ts).
  AUTH_MOCK: v(import.meta.env.REACT_APP_AUTH_MOCK),
  AZURE_FUNCTIONS_URL: v(import.meta.env.REACT_APP_AZURE_FUNCTIONS_URL),
  API_URL: v(import.meta.env.REACT_APP_API_URL),
  PUBLIC_SEARCH_URL: v(import.meta.env.REACT_APP_PUBLIC_SEARCH_URL) ?? 'https://search.scifree.se',
  SENTRY_DSN: v(import.meta.env.REACT_APP_SENTRY_DSN),
  BUILD: v(import.meta.env.REACT_APP_BUILD),
  SENTRY_DEPLOY_ENVIRONMENT: v(import.meta.env.REACT_APP_SENTRY_DEPLOY_ENVIRONMENT) ?? v(import.meta.env.VITE_SENTRY_DEPLOY_ENVIRONMENT),
  ENABLE_E2E_AUTH: v(import.meta.env.REACT_APP_ENABLE_E2E_AUTH),
  ZENDESK_BASE_URL: v(import.meta.env.REACT_APP_ZENDESK_BASE_URL),
  ZENDESK_SUBDOMAIN: v(import.meta.env.REACT_APP_ZENDESK_SUBDOMAIN),
  // SFDA-858: "zitadel" signs in through Zitadel and our login app; Auth0 is the default.
  AUTH_PROVIDER: v(import.meta.env.REACT_APP_AUTH_PROVIDER),
  ZITADEL_ISSUER: v(import.meta.env.REACT_APP_ZITADEL_ISSUER),
  ZITADEL_CLIENT_ID: v(import.meta.env.REACT_APP_ZITADEL_CLIENT_ID),
  ZITADEL_PROJECT_ID: v(import.meta.env.REACT_APP_ZITADEL_PROJECT_ID),
};

// For debugging
if (typeof window !== 'undefined') {
  (window as any).__ENV__ = env;
}